
import { 
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import InterviewScheduler from "./InterviewScheduler";

interface ScheduleInterviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  candidate: {
    name: string;
    email: string;
  };
}

const ScheduleInterviewDialog = ({ 
  isOpen, 
  onClose, 
  candidate 
}: ScheduleInterviewDialogProps) => {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent className="md:max-w-md overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Schedule Interview</SheetTitle>
        </SheetHeader>
        <InterviewScheduler 
          candidateName={candidate.name}
          candidateEmail={candidate.email}
          onClose={onClose}
        />
      </SheetContent>
    </Sheet>
  );
};

export default ScheduleInterviewDialog;
